/** TODO : need to pull orgs dynamically based on client */
export const getOrgs = (productCode: string): string[] => {
  if (productCode === "MAO") return ["UK", "US", "CA", "DE", "ES", "FR", "BE"];
  else return ["P13"];
};
